import { useNavigate } from 'react-router-dom'
import { useTheme } from '../context/ThemeContext'

const UPDATED = '15 июня 2026 г.'

const sections = [
  {
    title: '1. Общие положения',
    body: [
      '1.1. Настоящая Политика конфиденциальности (далее - «Политика») определяет порядок сбора, хранения, использования, передачи и защиты персональных данных пользователей веб-сервиса Welland Create (далее - «Сервис»).',
      '1.2. Оператором персональных данных является Индивидуальный предприниматель «Welland» (далее - «Оператор», «Мы»).',
      '1.3. Используя Сервис, регистрируя учетную запись или предоставляя персональные данные, Пользователь подтверждает ознакомление с настоящей Политикой и выражает согласие на обработку своих персональных данных в соответствии с ее условиями.',
      '1.4. Обработка персональных данных осуществляется в соответствии с законодательством Республики Казахстан, включая Закон Республики Казахстан «О персональных данных и их защите».',
    ],
  },
  {
    title: '2. Оператор персональных данных',
    body: [
      'Оператор:\nИндивидуальный предприниматель «Welland»\n\nМестонахождение:\nРеспублика Казахстан, г. Алматы\n\nКонтактный адрес электронной почты:\nwelland.info@mail.ru',
    ],
  },
  {
    title: '3. Какие данные мы собираем',
    body: [
      'В зависимости от способа регистрации и использования Сервиса мы можем собирать следующие категории данных.',
      '3.1. Персональные данные, предоставляемые Пользователем:\n\nимя;\nфамилия;\nадрес электронной почты;\nномер телефона;\nиные сведения, которые Пользователь добровольно указывает в профиле или обращениях.',
      '3.2. Данные, получаемые при авторизации через Google:\n\nимя и фамилия учетной записи Google;\nадрес электронной почты;\nидентификатор учетной записи Google;\nинформация о подтверждении электронной почты.\n\nМы не получаем пароль от учетной записи Google.',
      '3.3. Геолокационные данные:\n\nПри наличии разрешения со стороны Пользователя Сервис может получать информацию о примерном географическом местоположении для улучшения работы отдельных функций и аналитики использования Сервиса.\n\nПользователь может в любой момент отключить доступ к геолокации через настройки браузера или устройства.',
      '3.4. Данные проектов:\n\nпараметры бассейнов;\nхарактеристики оборудования;\nконфигурации проектов;\nспецификации;\nвизуализации;\nиные данные, создаваемые Пользователем в процессе работы.',
      '3.5. Технические данные:\n\nIP-адрес;\nтип браузера;\nверсия браузера;\nоперационная система;\nязык интерфейса;\nсведения об устройстве;\nдата и время доступа;\nжурналы действий пользователя;\nданные файлов cookie и аналогичных технологий.',
    ],
  },
  {
    title: '4. Цели обработки персональных данных',
    body: [
      'Мы обрабатываем данные исключительно для следующих целей:\n\nрегистрация и обслуживание учетной записи;\nпредоставление доступа к функциональности Сервиса;\nсохранение и синхронизация проектов;\nформирование спецификаций и документов;\nобеспечение безопасности учетных записей;\nпредотвращение мошенничества и злоупотреблений;\nтехническая поддержка пользователей;\nулучшение качества работы Сервиса;\nпроведение аналитики и статистических исследований;\nисполнение требований законодательства Республики Казахстан.',
    ],
  },
  {
    title: '5. Правовые основания обработки',
    body: [
      'Обработка персональных данных осуществляется на следующих основаниях:\n\nсогласие Пользователя;\nнеобходимость исполнения Пользовательского соглашения;\nвыполнение обязанностей, предусмотренных законодательством;\nзаконный интерес Оператора, связанный с обеспечением безопасности и стабильной работы Сервиса.',
    ],
  },
  {
    title: '6. Файлы Cookie и аналогичные технологии',
    body: [
      '6.1. Сервис использует файлы cookie, локальное хранилище браузера и иные технические средства для обеспечения корректной работы.',
      '6.2. Cookie могут использоваться для:\n\nаутентификации пользователя;\nсохранения настроек интерфейса;\nобеспечения безопасности;\nанализа использования Сервиса;\nулучшения пользовательского опыта.',
      '6.3. Пользователь вправе изменить настройки использования cookie через свой браузер.\n\nОтключение отдельных cookie может привести к ограничению функциональности Сервиса.',
    ],
  },
  {
    title: '7. Аналитика и статистика',
    body: [
      '7.1. Для анализа работы Сервиса могут использоваться сторонние системы аналитики и мониторинга.',
      '7.2. Такие системы могут собирать обезличенные сведения о посещениях Сервиса, включая:\n\nдействия пользователей;\nтехнические параметры устройств;\nсведения о посещенных страницах;\nпродолжительность сессий;\nисточники переходов.',
      '7.3. Аналитические данные используются исключительно для улучшения качества работы Сервиса.',
    ],
  },
  {
    title: '8. Передача персональных данных третьим лицам',
    body: [
      '8.1. Мы не продаем и не передаем персональные данные третьим лицам в коммерческих целях.',
      '8.2. Передача данных допускается только в следующих случаях:\n\nпоставщикам технических услуг, обеспечивающим работу Сервиса;\nсервисам авторизации Google;\nпоставщикам аналитических сервисов;\nпочтовым сервисам для отправки уведомлений;\nгосударственным органам в случаях, предусмотренных законодательством;\nв иных случаях при наличии законных оснований.',
      '8.3. Передача осуществляется только в объеме, необходимом для достижения соответствующей цели.',
    ],
  },
  {
    title: '9. Хранение и защита данных',
    body: [
      '9.1. Персональные данные хранятся на серверах, размещенных на территории Республики Казахстан.',
      '9.2. Для защиты данных применяются организационные и технические меры безопасности, включая:\n\nиспользование защищенного соединения HTTPS;\nограничение доступа к данным;\nаутентификацию и контроль доступа;\nхранение паролей в зашифрованном виде;\nмониторинг безопасности системы.',
      '9.3. Несмотря на принимаемые меры, абсолютная безопасность передачи данных через интернет не может быть гарантирована.',
    ],
  },
  {
    title: '10. Срок хранения данных',
    body: [
      '10.1. Персональные данные хранятся в течение срока существования учетной записи Пользователя.',
      '10.2. После удаления учетной записи данные удаляются либо обезличиваются в течение 30 календарных дней, если более длительный срок хранения не требуется законодательством или необходим для защиты законных интересов Оператора.',
      '10.3. Резервные копии могут храниться в течение дополнительного технического периода, необходимого для обеспечения восстановления системы.',
    ],
  },
  {
    title: '11. Права пользователя',
    body: [
      'Пользователь вправе:\n\nполучать информацию о своих персональных данных;\nтребовать уточнения или обновления данных;\nотозвать согласие на обработку данных;\nпотребовать удаления персональных данных в случаях, предусмотренных законодательством;\nнаправлять обращения по вопросам обработки данных.',
      'Для реализации указанных прав Пользователь может обратиться по адресу электронной почты:\n\nwelland.info@mail.ru',
    ],
  },
  {
    title: '12. Международные пользователи',
    body: [
      '12.1. Сервис может использоваться пользователями, находящимися за пределами Республики Казахстан.',
      '12.2. Используя Сервис, Пользователь соглашается с тем, что его данные будут обрабатываться в соответствии с законодательством Республики Казахстан и настоящей Политикой.',
    ],
  },
  {
    title: '13. Данные несовершеннолетних',
    body: [
      '13.1. Сервис не предназначен для самостоятельного использования лицами младше 18 лет.',
      '13.2. Оператор не осуществляет целенаправленный сбор персональных данных несовершеннолетних.',
      '13.3. При выявлении факта предоставления данных несовершеннолетним без согласия законного представителя соответствующие данные могут быть удалены.',
    ],
  },
  {
    title: '14. Изменение Политики',
    body: [
      '14.1. Оператор вправе вносить изменения в настоящую Политику.',
      '14.2. Новая редакция вступает в силу с момента публикации на Сайте, если иное не предусмотрено новой редакцией.',
      '14.3. Продолжение использования Сервиса после вступления изменений в силу означает согласие Пользователя с новой редакцией Политики.',
    ],
  },
  {
    title: '15. Контактная информация',
    body: [
      'Индивидуальный предприниматель «Welland»\n\nРеспублика Казахстан, г. Алматы\n\nТелефон / WhatsApp: +7 (777) 229-62-25\n\nEmail: welland.info@mail.ru',
    ],
  },
]

export default function PrivacyPage() {
  const { dark } = useTheme()
  const navigate = useNavigate()

  const bg   = dark ? '#010810' : '#F0F5F9'
  const card = dark ? '#05111F' : '#FFFFFF'
  const line = dark ? 'rgba(255,255,255,.08)' : 'rgba(10,32,40,.09)'
  const text = dark ? 'rgba(255,255,255,.88)' : '#0A2028'
  const muted= dark ? 'rgba(255,255,255,.45)' : 'rgba(10,32,40,.5)'
  const head = dark ? '#fff' : '#0A2028'

  return (
    <div style={{
      minHeight: '100vh', background: bg,
      fontFamily: "'Plus Jakarta Sans',system-ui,sans-serif",
      WebkitFontSmoothing: 'antialiased',
      backgroundImage: dark
        ? 'radial-gradient(ellipse 70% 40% at 50% 0%,rgba(15,163,177,.1) 0%,transparent 70%)'
        : 'radial-gradient(ellipse 70% 40% at 50% 0%,rgba(15,163,177,.07) 0%,transparent 70%)',
    }}>
      {/* Nav */}
      <div style={{ borderBottom: `1px solid ${line}`, padding: '0 28px' }}>
        <div style={{ maxWidth: 860, margin: '0 auto', height: 60, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <button onClick={() => navigate(-1)} style={{
            background: 'none', border: 'none', cursor: 'pointer',
            display: 'flex', alignItems: 'center', gap: 8, color: '#0FA3B1',
            fontSize: 13, fontWeight: 700, fontFamily: 'inherit', padding: 0,
          }}>
            ← Вернуться назад
          </button>
          <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 10, letterSpacing: '.18em', color: muted, textTransform: 'uppercase' }}>
            Welland Create
          </span>
        </div>
      </div>

      {/* Content */}
      <div style={{ maxWidth: 860, margin: '0 auto', padding: '52px 28px 80px' }}>
        <div style={{ background: card, borderRadius: 20, border: `1px solid ${line}`, boxShadow: dark ? '0 24px 60px rgba(0,0,0,.4)' : '0 4px 24px rgba(10,32,40,.07)', overflow: 'hidden' }}>

          {/* Header */}
          <div style={{ padding: '44px 52px 36px', borderBottom: `1px solid ${line}`, background: dark ? 'rgba(15,163,177,.04)' : 'rgba(15,163,177,.03)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
              <div style={{ width: 36, height: 36, borderRadius: 10, background: 'rgba(15,163,177,.12)', border: '1px solid rgba(15,163,177,.25)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0FA3B1" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
              </div>
              <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 10, letterSpacing: '.2em', color: '#0FA3B1', textTransform: 'uppercase', fontWeight: 700 }}>Welland Create</span>
            </div>
            <h1 style={{ fontSize: 'clamp(22px,4vw,34px)', fontWeight: 900, color: head, letterSpacing: '-.025em', lineHeight: 1.1, margin: 0 }}>
              Политика конфиденциальности
            </h1>
            <p style={{ fontSize: 14, color: muted, marginTop: 10, lineHeight: 1.6 }}>
              Последнее обновление: <b style={{ color: text }}>{UPDATED}</b>
            </p>
            <div style={{ marginTop: 16, padding: '12px 16px', background: dark ? 'rgba(15,163,177,.08)' : 'rgba(15,163,177,.07)', borderRadius: 10, border: `1px solid ${dark ? 'rgba(15,163,177,.2)' : 'rgba(15,163,177,.18)'}` }}>
              <p style={{ fontSize: 13.5, color: text, lineHeight: 1.65, margin: 0 }}>
                Мы серьёзно относимся к защите ваших персональных данных. Настоящий документ описывает, какие данные мы собираем, как используем и как защищаем.
              </p>
            </div>
          </div>

          {/* Sections */}
          <div style={{ padding: '40px 52px 52px', display: 'flex', flexDirection: 'column', gap: 0 }}>
            {sections.map((s, i) => (
              <div key={i} style={{ paddingBottom: 32, marginBottom: 32, borderBottom: i < sections.length - 1 ? `1px solid ${line}` : 'none' }}>
                <h2 style={{ fontSize: 17, fontWeight: 800, color: head, marginBottom: 14, letterSpacing: '-.015em' }}>{s.title}</h2>
                {s.body.map((p, j) => (
                  <p key={j} style={{ fontSize: 14.5, color: text, lineHeight: 1.75, margin: j > 0 ? '12px 0 0' : 0, whiteSpace: 'pre-line' }}>{p}</p>
                ))}
              </div>
            ))}
          </div>

          {/* Footer */}
          <div style={{ borderTop: `1px solid ${line}`, padding: '20px 52px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
            <span style={{ fontSize: 12.5, color: muted }}>© 2025 Welland. Все права защищены.</span>
            <button onClick={() => navigate('/terms')} style={{
              background: 'none', border: 'none', cursor: 'pointer',
              color: '#0FA3B1', fontSize: 13, fontWeight: 600, fontFamily: 'inherit', padding: 0,
            }}>
              Пользовательское соглашение →
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
